<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue'

import { useEditorStore } from '@/stores/Editor'
import { useAccountStore } from '@/stores/Account'
import { useEditorFrame, EVENT_TYPES } from '@/composables/iframe'
import { useCloudinary } from '@/composables/cloudinary'

import EditorHeader from '@/components/editor/EditorHeader.vue'
import EditorSidebar from '@/components/editor/EditorSidebar.vue'
import EditorContent from '@/components/editor/EditorContent.vue'
import FullPageLoader from '@/components/common/FullPageLoader.vue'

const editorStore = useEditorStore()
const accountStore = useAccountStore()
const html = document.querySelector('html')
const { dispatchMessage, getIframeEl } = useEditorFrame()
const { insertUploadWidgetScript } = useCloudinary()

editorStore.$subscribe((mutation, state) => {
  dispatchMessage(getIframeEl(), {
    type: EVENT_TYPES.UPDATE_EDITOR_STORE,
    payload: JSON.parse(JSON.stringify(state)),
  })
})

onMounted(() => {
  if (html) {
    html.style.overflowY = 'hidden'
  }

  insertUploadWidgetScript()

  editorStore.loading = true

  accountStore.fetchSubscriptions()
})

onUnmounted(() => {
  if (html) {
    html.style.overflowY = 'auto'
  }
})
</script>

<template>
  <FullPageLoader v-if="editorStore.loading" />
  <div
    v-if="accountStore.subscriptions && accountStore.subscriptions.length > 0"
    class="editor"
    :class="{ preview: editorStore.previewMode }"
  >
    <EditorHeader />
    <EditorSidebar />
    <EditorContent />
  </div>
</template>

<style lang="scss" scoped>
.editor {
  height: 100vh;
  display: grid;
  grid-template-rows: 70px auto;
  grid-template-columns: 425px auto;
  grid-template-areas:
    'header header'
    'sidebar content';

  @include media('sm-and-down') {
    grid-template-rows: 56px auto;
  }

  &.preview {
    grid-template-columns: auto;
    grid-template-areas:
      'header'
      'content';

    :deep(.editor-sidebar) {
      position: absolute;
      right: -100%;
      display: none;
    }

    :deep(.editor-content) {
      padding: 0;
    }

    :deep(.editor-frame) {
      height: 100vh;
    }
  }

  &:not(.preview) {
    @include media('sm-and-down') {
      grid-template-columns: auto;
      grid-template-areas:
        'header'
        'sidebar';

      :deep(.editor-content) {
        position: absolute;
        right: -100%;
        display: none;
      }
    }
  }
}
</style>
